import { SxProps, Theme } from "@mui/material";
import { getStyleLogin } from "../../utils/functions";

const LOGIN_STYLES = getStyleLogin();

export const sharedLoginTextFieldSx: SxProps<Theme> = {
    '& .MuiOutlinedInput-root': {
        '&:hover fieldset': {
            borderColor: LOGIN_STYLES.hoverColor,
        },
        '&.Mui-focused fieldset': {
            borderColor: LOGIN_STYLES.borderColor,
        },
    },
    '& .MuiInputLabel-root': {
        '&.Mui-focused': {
            color: LOGIN_STYLES.labelColor,
        },
    },
};